export const MEDIA_QUERY_BREAKPOINT_S: string = '(min-width: 576px)';
export const MEDIA_QUERY_BREAKPOINT_MD: string = '(min-width: 768px)';
export const MEDIA_QUERY_BREAKPOINT_L: string = '(min-width: 992px)';
export const MEDIA_QUERY_BREAKPOINT_XL: string = '(min-width: 1200px)';
export const MEDIA_QUERY_BREAKPOINT_XXL: string = '(min-width: 1400px)';
export const MEDIA_QUERY_HEIGHT_BREAKPOINT_M: string = '(min-height: 850px)';
